import React, { Fragment, useEffect, Suspense } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider, responsiveFontSizes } from "@mui/material/styles";
import { lightTheme, blackTheme } from "../assets/theme/generalTheme";
import Layout from "./Layout/Layout";
import { Routes, Route } from "react-router-dom";
import { generalPortalRoutes, pathRoute } from "./Utils/Routes/routes";
/////////////////////////////////////////////////////
import CreateNavLinks from "./Layout/SideBarNav/CreateNavLinks";
import CustomLoading from "./Utils/Custom/CustomLoading";
import PrivateRoute from "./Auth/PrivateRoute";
import { connect } from "react-redux";
import Page404 from "./Utils/Custom/Page404";
import SignIn from "./Pages/SignIn/SignIn";
import { toast } from "react-toastify";
import StoreStateModel from "./Utils/Models/store";
import ErrorBoundary from "./Utils/Custom/ErrorBoundary";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Page500 from "./Utils/Custom/Page500";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import ForgotPassword from "./Pages/SignIn/ForgotPassword";
import RedirectEmailActions from "./Pages/SignIn/RedirectEmailActions";
console.log("env", process.env.NODE_ENV);
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY,
  environment: process.env.NODE_ENV || "unknown",
  // autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,

  // this avoid to capture errors during development in localhost
  // beforeSend: (event) => {
  //   if (window.location.hostname === 'localhost') {
  //     return null;//null
  //   }
  //   return event;
  // },
  beforeSend(event, hint) {
    // Check if it is an exception, and if so, show the report dialog
    if (event.exception) {
      // Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  },

  //this fix the issues with the payload too large ==> https://github.com/getsentry/sentry-javascript/issues/2798
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === "console") {
      return null;
    }
    return breadcrumb;
  },
});
interface Props {
  showLoadingComponent?: boolean;
  isAuthenticated?: boolean;
  isVerifying?: boolean;
  scopes?: string[];
  interceptorErrorMessage?: string;
  interceptorErrorId?: number;
  prefersDarkMode?: boolean;
  hasPermissionPortalAccessRead?: boolean;
  userId?: string;
  accountId?: number;
  email?: string;
  userName?: string;
  token?: string;
  accountFullName?: string;
}
function PagesRouteLogic({
  showLoadingComponent,
  isAuthenticated,
  isVerifying,
  scopes,
  interceptorErrorMessage,
  interceptorErrorId,
  prefersDarkMode,
  hasPermissionPortalAccessRead,
  userId,
  accountId,
  email,
  userName,
  token,
  accountFullName,
}: Props) {
  Sentry.configureScope(function (scope) {
    scope.setUser({
      email: email,
      name: userName,
    });
  });
  Sentry.setContext("Permissions", {
    scopes: JSON.stringify(scopes),
  });

  useEffect(() => {
    if (interceptorErrorMessage) {
      toast.error(interceptorErrorMessage, { toastId: interceptorErrorId });
    }
    return () => {
      toast.dismiss(interceptorErrorId);
    };
  }, [interceptorErrorId]);

  const theme = React.useMemo(
    () => createTheme(prefersDarkMode ? blackTheme : (lightTheme as any)),
    [prefersDarkMode]
  );
  // theme = responsiveFontSizes(theme);

  return (
    <Fragment>
      {/* It allows you to customize all design aspects of your project in order to meet the specific needs of your business or brand. */}
      <ThemeProvider theme={theme}>
        {/* fixes some inconsistencies across browsers and devices while providing slightly more opinionated resets to common HTML elements */}
        <CssBaseline />
        {/* ----- */}
        <Sentry.ErrorBoundary
          showDialog={false}
          fallback={({ error, componentStack, resetError }) => {
            return (
              <React.Fragment>
                <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
                  <Page500 />
                  <Button
                    style={{ marginTop: "20px" }}
                    color={"primary"}
                    variant={"contained"}
                    onClick={() =>
                      //  When resetError() is called it will remove the Fallback component
                      //  and render the Sentry ErrorBoundary's children in their initial state
                      resetError()
                    }
                  >
                    {"Back"}
                  </Button>
                </Grid>
              </React.Fragment>
            );
          }}
        >
          <Routes>
            {generalPortalRoutes.map((route) => {
              return (
                <Route
                  key={route.id}
                  path={route.path}
                  element={
                    <PrivateRoute
                      path={route.path}
                      autorization={route.authorization}
                      isAuthenticated={isAuthenticated as any}
                      hasPermissionPortalAccessRead={true}
                      isVerifying={isVerifying as any}
                      scopes={scopes as any}
                      element={
                        showLoadingComponent ? (
                          <CustomLoading />
                        ) : (
                          <Layout
                            sideBarNavList={
                              <CreateNavLinks
                                accountFullName={accountFullName}
                                userName={userName}
                                scopes={scopes as any}
                              />
                            }
                          >
                            <ErrorBoundary>
                              <Suspense fallback={<CustomLoading />}>
                                {route.mainContentComponent}
                              </Suspense>
                            </ErrorBoundary>
                          </Layout>
                        )
                      }
                    />
                  }
                />
              );
            })}
            <Route path={pathRoute.SignIn.Index} element={<SignIn />} />
            <Route path={pathRoute.SignIn.ForgotPassword} element={<ForgotPassword />} />
            <Route path={pathRoute.Action} element={<RedirectEmailActions />} />

            <Route
              path="*"
              element={
                isVerifying ? (
                  <CustomLoading />
                ) : isAuthenticated ? (
                  <Layout
                    sideBarNavList={
                      <CreateNavLinks
                        accountFullName={accountFullName}
                        userName={userName}
                        scopes={scopes as any}
                      />
                    }
                  >
                    <Page404 />
                  </Layout>
                ) : (
                  <Page404 />
                )
              }
            />
          </Routes>
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </Fragment>
  );
}
const mapStateToProps = (state: StoreStateModel /*, ownProps*/) => {
  return {
    //NOTE: dont use useSelector hooks here
    showLoadingComponent: state.general.showLoadingComponent,
    isAuthenticated: state.auth.isAuthenticated,
    isVerifying: state.auth.isVerifying,
    scopes: state.auth.scopes,
    interceptorErrorMessage: state.general.interceptorErrorMessage,
    interceptorErrorId: state.general.interceptorErrorId,
    prefersDarkMode: state.layout.prefersDarkMode,
    hasPermissionPortalAccessRead: state.auth.hasPermissionPortalAccessRead,
    userId: state.auth.uid,
    accountId: state.auth.accountId,
    email: state.auth.email,
    userName: state.auth.userName,
    token: state.auth.token,
    accountFullName: state.auth.accountName,
  };
};

export default connect(mapStateToProps, null)(PagesRouteLogic);
